import { render, staticRenderFns } from "./overview-data.vue?vue&type=template&id=2b82b495"
import script from "./overview-data.vue?vue&type=script&lang=js"
export * from "./overview-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports